<template>
    <div>
        <NavbarStyleTwo />
        <PageTitle pageTitle="Betreuung & Wartung" pageDesc="Langfristige Unterstützung für Ihre Webseite" />
        <BetreuungDetails />
        <Footer :showDivider="true" />
    </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import NavbarStyleTwo from '../Layouts/NavbarStyleTwo';
import PageTitle from '../Common/PageTitle';
import BetreuungDetails from '../SingleService/BetreuungDetails'
import Footer from '../Layouts/Footer'

export default {
    name: 'BetreuungPage',
    setup() {
        useHead({
            title: 'Webseiten-Betreuung & Wartung Wien | Benovium',
            meta: [
                { name: 'description', content: 'Professionelle Webseiten-Betreuung aus Wien. Updates, Sicherheit, Backups und technischer Support. Monatlich kündbar, transparente Preise.' },
                { property: 'og:title', content: 'Webseiten-Betreuung Wien - Benovium' },
                { property: 'og:description', content: 'Updates, Sicherheit und Support für Ihre Webseite.' },
                { property: 'og:url', content: 'https://benovium.com/services/betreuung' },
            ],
            link: [
                { rel: 'canonical', href: 'https://benovium.com/services/betreuung' }
            ]
        });
    },
    components: {
        NavbarStyleTwo,
        PageTitle,
        BetreuungDetails,
        Footer,
    }
};
</script>
